const tg = window.Telegram?.WebApp;

/**
 * Получает Telegram Chat ID текущего пользователя
 * @returns {number|null} - ID пользователя или null, если недоступно
 */
export const getTelegramUserId = () => {
    if (tg?.initDataUnsafe?.user?.id) {
        return tg.initDataUnsafe.user.id;
    }
    return null;
};

/**
 * Формирует ссылку на бота с referral параметром (start_param)
 * @param {string} botUsername - Имя бота (например, "my_bot" без @)
 * @param {number|null} [userId] - ID пользователя для referral (если не указан, берется текущий)
 * @returns {string} - Ссылка вида https://t.me/botUsername?start=userId
 */
export const buildBotShareUrl = (botUsername, userId = null) => {
    const referralUserId = userId || getTelegramUserId();
    const botName = botUsername?.replace('@', '') || 'kitmorozbot'; // Убираем @ если есть

    if (referralUserId) {
        return `https://t.me/${botName}?start=${referralUserId}`;
    }
    return `https://t.me/${botName}`;
};

/**
 * Открывает канал для подписки
 * @param {string} channelUrl - URL канала (опционально, можно передать из конфига)
 */
export const subscribeToChannel = (channelUrl = 'https://t.me/kitmorozbot') => {
    if (tg && tg.openTelegramLink) {
        tg.openTelegramLink(channelUrl);
    } else {
        // Fallback для разработки в браузере
        window.open(channelUrl, '_blank');
    }
};

/**
 * Открывает окно "Поделиться" в Telegram
 * @param {string} [shareUrl] - URL для шаринга (если это имя бота, будет сформирована ссылка с referral)
 * @param {string} [text] - Опциональный текст сообщения
 * @param {string} [botUsername] - Имя бота для формирования referral ссылки (приоритет над shareUrl)
 */
export const shareApp = (shareUrl = null, text = 'Я отправил письмо Деду Морозу через Яндекс КИТ! 🎅✨', botUsername = null) => {
    let finalShareUrl;

    // Если явно указано имя бота, используем его
    if (botUsername) {
        finalShareUrl = buildBotShareUrl(botUsername);
    }
    // Если shareUrl указан и это ссылка на бота (t.me/...), извлекаем имя бота и добавляем referral
    else if (shareUrl && shareUrl.includes('t.me/')) {
        const username = shareUrl.replace('https://t.me/', '').replace('http://t.me/', '').split('?')[0].split('/')[0].replace('@', '');
        finalShareUrl = buildBotShareUrl(username);
    }
    // Если shareUrl не указан или не является ссылкой, используем дефолтное имя бота
    else {
        const defaultBotName = shareUrl?.replace('@', '') || 'kitmorozbot';
        finalShareUrl = buildBotShareUrl(defaultBotName);
    }

    const url = `https://t.me/share/url?url=${encodeURIComponent(finalShareUrl)}&text=${encodeURIComponent(text)}`;

    if (tg && tg.openTelegramLink) {
        tg.openTelegramLink(url);
    } else {
        // Fallback для разработки в браузере
        window.open(url, '_blank');
    }
};

/**
 * Показывает нативное всплывающее окно (Alert)
 * @param {string} message - Текст сообщения
 * @param {function} [callback] - Функция, вызываемая после закрытия окна
 */
export const showTelegramAlert = (message, callback) => {
    if (tg && tg.showAlert) {
        tg.showAlert(message, callback);
    } else {
        // Fallback для браузера
        alert(message);
        if (callback) callback();
    }
};

/**
 * Вызывает Haptic Feedback (impactOccurred)
 * @param {string} style - Стиль вибрации: 'light', 'medium', 'heavy', 'rigid', 'soft'
 */
export const triggerHaptic = (style = 'medium') => {
    if (tg && tg.HapticFeedback && tg.HapticFeedback.impactOccurred) {
        tg.HapticFeedback.impactOccurred(style);
    }
};

/**
 * Вызывает Notification Feedback (notificationOccurred)
 * @param {string} type - Тип уведомления: 'error', 'success', 'warning'
 */
export const triggerNotification = (type = 'success') => {
    if (tg && tg.HapticFeedback && tg.HapticFeedback.notificationOccurred) {
        tg.HapticFeedback.notificationOccurred(type);
    }
};

/**
 * Вызывает Selection Feedback (selectionChanged)
 */
export const triggerSelection = () => {
    if (tg && tg.HapticFeedback && tg.HapticFeedback.selectionChanged) {
        tg.HapticFeedback.selectionChanged();
    }
};
